import React from 'react';

import { Typography, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';

const CreditCard = ({
  card,
}) => {
  return (
    <Grid container spacing={1} sx={{ marginBottom: '10px' }} display="flex" alignItems="center" maxWidth="90%">
      <Grid item sm={1} xs={1}>
        { card.default && (
          <CheckCircleIcon fontSize="small" htmlColor="#06c" />
        )}
      </Grid>
      <Grid item sm={7} xs={11}>
        <Typography>
          {card.card_type_name.toUpperCase()}
          {' '}
          -
          {' '}
          {card.obscured_card_number}
          {' '}
          (Exp.
          {' '}
          {card.expiration_month}
          /
          {card.expiration_year}
          )
        </Typography>
      </Grid>

      <Grid item sm={1} xs={1} />
      <Grid item sm={1} xs={2}>
        <a
          title="Edit"
          role="link"
          className="bluelink"
          tabIndex="0"
          onClick={() => {
          }}
        >
          Edit
        </a>
      </Grid>
      <Grid item sm={2} xs={5}>
        <a
          title="Delete"
          role="link"
          className="bluelink"
          tabIndex="0"
          onClick={() => {
          }}
        >
          Delete
        </a>
      </Grid>
    </Grid>
  );
};

CreditCard.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.number.isRequired,
    card_type_name: PropTypes.string.isRequired,
    obscured_card_number: PropTypes.string.isRequired,
    expiration_month: PropTypes.number.isRequired,
    expiration_year: PropTypes.number.isRequired,
    default: PropTypes.bool,
  }).isRequired,
};

export default CreditCard;
